export const DST_AMBIGUOUS_ERROR = 'DST_AMBIGUOUS_ERROR';
export const DST_AMBIGUOUS_ERROR_TEXT = 'Daylight Savings makes this timeframe ambiguous. Users must use the GMT timezone preference to book in this timeframe.';
export const DST_WARNING_TEXT = 'The durations of bookings that overlap the start or stop of Daylight Savings will be affected.\n\nPress OK to continue.';
export const FULL_TIME_STR = '2100-01-01T00:00:00.000Z';
